import { animateScroll as scroll } from 'react-scroll'

// uses react-scroll package to scroll to top
export const scrollToTop = () => {
  scroll.scrollToTop()
}
